import { createParser } from 'nuqs';

const SEPARATOR = ',';

/**
 * nuqs parser for a single query param whose value is a comma-separated list.
 * Parses e.g. "a,b,c" into ["a","b","c"] and serializes back to "a,b,c".
 * Empty or whitespace-only segments are filtered out.
 */
export const parseAsCommaSeparatedList = createParser<string[]>({
  parse(value) {
    if (value == null || typeof value !== 'string') {
      return [];
    }
    return value
      .split(SEPARATOR)
      .map((s) => s.trim())
      .filter(Boolean);
  },
  serialize(value) {
    if (!value?.length) {
      return '';
    }
    return value.join(SEPARATOR);
  },
  eq(a, b) {
    if (a.length !== b.length) return false;
    return a.every((item, i) => item === b[i]);
  },
});
